import type { LearningObjectiveDto } from './types';

function learningObjectivesProgress(learningObjectives: LearningObjectiveDto[] | undefined) {
    let completed = 0;
    let total = 0;
    for (const group of learningObjectives ?? []) {
        const done = group.e251_CompletedObjectives?.length ?? 0;
        const incomplete = group.e251_IncompleteObjectives?.length ?? 0;
        completed += done;
        total += done + incomplete;
    }
    const pct = total === 0 ? 0 : Math.round((completed / total) * 100);
    return { completed, total, pct };
}

interface UnitCardHeaderObjectivesProgressProps {
    learningObjectives?: LearningObjectiveDto[];
}

/** Thin progress row for learning objectives (completed unit card header). */
export function UnitCardHeaderObjectivesProgress({
    learningObjectives,
}: UnitCardHeaderObjectivesProgressProps) {
    const { completed, total, pct } = learningObjectivesProgress(learningObjectives);

    if (total === 0) {
        return null;
    }

    return (
        <div
            className="mt-3 w-full text-xs text-gray-600"
            onClick={(e) => e.stopPropagation()}
            role="presentation"
        >
            <div className="mb-1 flex items-center justify-between gap-2">
                <span className="truncate text-gray-500">Learning objectives completed</span>
                <span className="shrink-0 tabular-nums text-gray-700">
                    {completed} / {total}
                </span>
            </div>
            <div className="h-1 w-full overflow-hidden rounded-full bg-gray-300/80">
                <div
                    className="h-full rounded-full bg-confirm-action transition-[width] duration-300 ease-out"
                    style={{ width: `${pct}%` }}
                />
            </div>
        </div>
    );
}
